import { createLazyOrchestrator } from 'owa-bundling';
import { getSearchState } from 'owa-calendar-search-view-store';
import {
    getSuggestions,
    onSearchScopeOptionSelected,
    resetCurrentSuggestions,
    startSearch,
} from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';
import {
    setNonSearchableCalendarsText,
    setAccountScope,
    setCalendarFoldersScope,
} from 'owa-calendar-search-store';

export const onSearchScopeOptionSelectedOrchestrator = createLazyOrchestrator(
    onSearchScopeOptionSelected,
    'CLONE_CALENDAR_SEARCH_OPTION_SELECTED',
    actionMessage => {
        if (actionMessage.searchScenarioType != SearchScenarioId.Calendar) {
            return;
        }

        setAccountScope(false, actionMessage.selectedSearchScope);

        // Initialize folder scope data (based on currently selected node).
        setCalendarFoldersScope(null);

        // VSO 85371 TODO: If the account scope is set to a connected account, then we will also initialize the search query
        // for the connected account since that would not have been done by the SearchScopePicker

        setNonSearchableCalendarsText(true);

        // Reset existing suggestions
        resetCurrentSuggestions(SearchScenarioId.Calendar);

        if (getSearchState()) {
            startSearch('AccountScopePicker', SearchScenarioId.Calendar);
        } else {
            getSuggestions(SearchScenarioId.Calendar);
        }
    }
);
